import React from 'react';

function StickyNav({
  step, serviceCart, selectedOptionalAddOns, selectedMandatoryAddOns,
  selectedTime, guestInfo, guestSelections,
  bookingConfirmed, bookingLoading, policyAgreed,
  onBack, onGuestListNext,
  selectedServices, selectedTherapists, onProceedFromServices, proceedingFromServices,
  onMandatoryAddOnsContinue, isWaxingStep, onBuildCartAndContinue, onContinueToTime,
  onTimeNext, onConfirmBooking, reserving,
  onGuestCountDefault
}) {
  if (step <= 1 || step === 5 || step >= 11) return null;

  return (
    <>
      {/* Sticky Bottom Nav */}
      <div className="sticky-nav">
          <button className="sticky-nav-back" onClick={onBack}>BACK</button>

          {step === 2 && (
            <button className="sticky-nav-next" onClick={onGuestCountDefault}>
              NEXT
            </button>
          )}
          {step === 3 && (
            <button className="sticky-nav-next"
              onClick={onGuestListNext}
              disabled={!guestSelections.every(g => g.services && g.services.length > 0)}>
              NEXT
            </button>
          )}
          {step === 4 && selectedServices.length > 0 && (
            <button className="sticky-nav-next" onClick={onProceedFromServices}
              disabled={proceedingFromServices}>
              {proceedingFromServices ? 'LOADING...' : `NEXT — ${selectedServices.length} SERVICE${selectedServices.length > 1 ? 'S' : ''}`}
            </button>
          )}
          {step === 7 && (
            <button className="sticky-nav-next" onClick={onMandatoryAddOnsContinue}
              disabled={!isWaxingStep && selectedMandatoryAddOns.length === 0}>
              NEXT
            </button>
          )}
          {step === 8 && (() => {
            const allPicked = selectedServices && selectedServices.every(svc => {
              const t = selectedTherapists?.[svc.id];
              return t && (t.Id || t.id);
            });
            return (
              <button className="sticky-nav-next" onClick={onBuildCartAndContinue} disabled={!allPicked}>
                NEXT
              </button>
            );
          })()}
          {step === 8.5 && (
            <button className="sticky-nav-next" onClick={onContinueToTime}>
              NEXT
            </button>
          )}
          {step === 9 && (
            <button className="sticky-nav-next" onClick={onTimeNext} disabled={!selectedTime}>
              NEXT
            </button>
          )}
          {step === 10 && !bookingConfirmed && (
            <button className="sticky-nav-next"
              onClick={onConfirmBooking}
              disabled={bookingLoading || reserving || !policyAgreed}>
              {bookingLoading ? 'BOOKING...' : reserving ? 'RESERVING...' : !policyAgreed ? 'AGREE TO POLICY TO CONFIRM' : 'CONFIRM BOOKING'}
            </button>
          )}
      </div>
    </>
  );
}

export default StickyNav;
